import * as React from 'react';
import { Button } from '../../../../components/button/Button';
import ResultDialog from '../../../../components/dialog-types/ResultDialog';
import { TextArea } from '../../../../components/form-elements/_index';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageHeading } from '../../../../components/page-components/PageHeading';
import { PageNames } from '../../../../utils/app-constants';
import { SyncStatusFlyout } from '../components/SyncStatusFlyout';

export const SyncScene = () => {

    const [syncIds, setOrderIds]                 = React.useState('');
    const [isFlyoutOpen, setIsFlyoutOpen]       = React.useState(false);

    /**
     * Handler for changing the sync IDs.
     * @param e The event containing the new sync IDs
     */
    const onSyncIdChange = (e: any) => {
        setOrderIds(e.target.value);
    };

    const onReset = () => {
        setOrderIds('');
    };

    /** 
     * Confirm and initiate the sync process
     */
    const syncThem = async () => {

        const result = await ResultDialog.show({
            title: 'Sync Orders?',
            message: 'Are you sure you want to sync these orders? This will update the system with the provided IDs.'
        });

        if (result) {
            setIsFlyoutOpen(true);
        }
    };

    /**
     * Close the flyout
     */
    const closeFlyout = () => {
        setIsFlyoutOpen(false);
        onReset();
    };

    return (
        <PageContent pageName={PageNames.SUPPORT_SYNC_ORDERS}>
            <PageHeading>
                <button 
                    className="btn new negative"
                    onClick={ onReset }>
                    Reset
                </button>
            </PageHeading>
            <PageBody>
                <div className="row justify-content-around">
                    <div className="col">
                        <p>Enter the IDs you want to sync below, 1 ID per line</p>
                        <TextArea
                            id="syncIds"
                            className="reporting-shipmentexport-textarea"
                            label="Sync IDs"
                            value={ syncIds }
                            allowReturn={ true }
                            onChange={ onSyncIdChange } />
                        <Button 
                            id="sync-btn" 
                            testID="sync-btn" 
                            text="Sync" 
                            disable={ syncIds.length === 0 }
                            onBtnClick={ syncThem } 
                        />
                    </div>
                </div>

                <SyncStatusFlyout
                    isOpen={ isFlyoutOpen }
                    onClose={ closeFlyout }
                    orders={ syncIds }
                />

            </PageBody>
        </PageContent>
    );
};